export default "__VITE_ASSET__DXPYDbD9__"